export const initialState = {
  announcements: [],
};
